export class NotificationData{

  constructor(
    public title: string,
    public body: string,
    public img: string,
    public date: any
  ){}
}
